var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"dashbaord-link",attrs:{"to":_vm.link}},[(_vm.icon)?_c('v-icon',{attrs:{"left":""}},[_vm._v(_vm._s(_vm.icon))]):_vm._e(),_vm._v(_vm._s(_vm.texte))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }